var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipBalanced({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.47 12.28H18.06L16.27 8.61L14.47 12.28Z",
    fill: "#FFB900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94 12.28H9.52L7.73 8.61L5.94 12.28Z",
    fill: "#FFB900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM7.73 15.18C6.13 15.18 4.83 13.88 4.83 12.28H5.27L7.2 8.33H6.19C5.97 8.33 5.79 8.15 5.79 7.93C5.79 7.71 5.97 7.53 6.19 7.53H10.8V8.32H8.25L10.18 12.27H10.62C10.62 13.87 9.32 15.17 7.72 15.17L7.73 15.18ZM13.95 17.33H10.05V16.54H11.4V6.67H12.6V16.54H13.95V17.33ZM16.27 15.18C14.67 15.18 13.37 13.88 13.37 12.28H13.81L15.74 8.33H13.19V7.54H17.8C18.02 7.54 18.2 7.72 18.2 7.94C18.2 8.16 18.02 8.34 17.8 8.34H16.79L18.72 12.29H19.16C19.16 13.89 17.86 15.19 16.26 15.19L16.27 15.18Z",
    fill: "#FFB900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipBalanced);
export default __webpack_public_path__ + "static/media/ic-chip-balanced.ace13f1227ba27c4f20a8647b4b42a7e.svg";
export { ForwardRef as ReactComponent };